export default __webpack_public_path__ + "static/media/3.c51e5fd8.svg";